import React from "react";
import { CGE } from "../../../../common/components/CGE";
import Loading from "../../../../common/components/Loading";
import { changeCurrancyFormat, decode_utf8, removeChar } from "../../../../common/utils/utilsFunc";
import ConsultSubsidyContextProvider, {
    ConsultSubsidyContext,
    ACTIONS
} from "../../context/ConsultSubsidyContextProvider";
import "../../styles/index.scss";
import { useModal } from "@clayui/modal";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

const ConsultSubsidy = ({ props }) => {
    const [state, dispatch] = React.useContext(ConsultSubsidyContext);
    const [loading, setLoading] = React.useState(false);
    const [errorNumCli, setErrorNumCli] = React.useState("");
    const [numCli, setNumCli] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [nextStep, setNextStep] = React.useState(false);
    const [detailClientJson, setDetailClientJson] = React.useState([]);
    const [responseService, setResponseService] = React.useState('');
    const [responseServiceWebContent, setResponseServiceWebContent] = React.useState('');
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        },
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function handleClick() {
        setErrorNumCli(false);
        if (numCli && verifReCaptcha) {
            setLoading(true);
            setResponseService('');
            setDetailClientJson([]);
            setNextStep(false);
            dispatch({
                payload: numCli,
                type: ACTIONS.SET_SERV1,
            });
        } else if (!numCli) {
            setErrorNumCli(true);
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning")
        } else {
            props.setGlobalAlert("Falta validar que no eres un robot.", "warning");
        }
    }


    let propsLabelInfoContent = {
        "content": state?.webContentTextInfo,
        "observer": observer,
        "onClose": onClose,
        "setVisibleModal": setVisibleModal,
        "status": "info",
        "titleModal": "Información",
        "visibleModal": visibleModal,
        "titleHint": "Ayuda Nro de Cliente",
    }

    React.useEffect(() => {
        const objResponse = state.response_serv1
        setLoading(false);
        if (objResponse) {
            if(objResponse?.code === 0) {
                setResponseServiceWebContent(state.webContentTextResponseSuccess)
                setResponseService(objResponse)
                setNextStep(true);
            } else if(objResponse?.code === 1) {
                setResponseServiceWebContent(state.webContentTextResponseFail)
                setNextStep(true);
            } else {
                props.setGlobalAlert(objResponse?.message && objResponse.status !== 500 ? objResponse?.message :  props.text_fetch_error, "warning", true, "Advertencia");
                setResponseServiceWebContent('');
                setNextStep(false);
            }
        }
    },[state.response_serv1]);

    React.useEffect(() => {
        if(state.detailClient){
          if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
            if(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){
              setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
            } else {
                setLoading(false);
                setDetailClientJson([])
                props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error) ,"warning", true, "Advertencia");
            }
          } else {
            setLoading(false);
            setDetailClientJson([])
            props.setGlobalAlert(decode_utf8(props.text_fetch_error),"warning", true, "Advertencia");
          }
        }
    }, [state.detailClient])

    return (
        <>
            <CGE.Panel title={decode_utf8(props?.title_consult_subsidy)}>
                <CGE.Text
                    text={decode_utf8(props?.subtitle2_consult_subsidy)}
                    size="4"
                    style={{ color: '#00a7e1', fontWeight: 'normal' }}
                />
                <CGE.Spacing type="nl" />
                <CGE.DetailClient
                    props={{
                        handleChange: (e) => setNumCli(e.target.value),
                        horizontal: true,
                        hasError: errorNumCli,
                        msgError: "Debe ingresar el Nro. de Cliente.",
                        idClient: numCli === state.idClient ? numCli : "",
                        idFormElement: "clientId",
                        labelName: "Número de Cliente:",
                        mandatoryElement: true,
                        onInput: (e) => e.target.value = e.target.value.slice(0, 12),
                        placeholder: "Ingresar el numero de cliente",
                        sizeButton: "sm",
                        typeButton: "primary",
                        typeElement: "input",
                        typeFormElement: "number",
                        valuePub: numCli,
                        propsLabelInfoContent:propsLabelInfoContent
                    }}
                    propsDetail={{
                        fullNameClient: "",
                        comunaClient: detailClientJson?.COMUNA ? detailClientJson?.COMUNA : "",
                        calleClient: detailClientJson?.CALLE ? detailClientJson?.CALLE : "",
                        nCalleClient: detailClientJson?.NUMERO_CASA ? detailClientJson?.NUMERO_CASA : "",
                        dptoBlockClient: (detailClientJson?.SUPLEMENTO || detailClientJson?.PISO) ? `${detailClientJson?.SUPLEMENTO} 
                            ${detailClientJson?.PISO}` : "",
                        ctaCtoClient: detailClientJson?.CTA_CTO
                    }}
                />
                <div className="detail-client-horizontal">
                    <CGE.Spacing type="md" />
                    <CGE.FieldRecaptcha
                        horizontal={true}
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                    />
                </div>
                <div>
                    <CGE.Button
                        className="mx-auto"
                        label="Buscar"
                        onClick={() => {
                            handleClick();
                        }}
                    />
                </div>
                <CGE.Spacing type="nl" />
                {nextStep && (numCli === state.idClient) &&
                    <CGE.PanelContainer
                    alingItensCenter={true}
                    size="lg"
                  >
                      
                        <div className="row">
                            {responseService?.montoDeuda && <div className="col-md-6">
                                <CGE.Card 
                                    label={decode_utf8(props?.title_card1_consult_subsidy)} 
                                    dataInfoShow={`${responseService?.montoDeuda.includes("$") ? changeCurrancyFormat(removeChar(responseService?.montoDeuda, "$")) : changeCurrancyFormat(responseService?.montoDeuda)}`} 
                                    disabled={false}
                                />
                            </div>}
                            {responseService?.consumoPromedio && <div className="col-md-6">
                                <CGE.Card 
                                    label={decode_utf8(props?.title_card2_consult_subsidy)}  
                                    dataInfoShow={`${responseService?.consumoPromedio.includes("$") ? removeChar(responseService?.consumoPromedio, "$")+" KWHr/mes": responseService?.consumoPromedio+" KWHr/mes"}`} 
                                    disabled={false} 
                                />
                            </div>}
                        </div>
                        <CGE.RenderContent className="info-text-consult-subsidy" textContent={responseServiceWebContent} />
                    </CGE.PanelContainer>
                }
            </CGE.Panel>
            {loading && <Loading />}
        </>
    );
};

const ConsultSubsidyWithProvider = ({ props }) => (
    <ConsultSubsidyContextProvider>
        <ConsultSubsidy props={props} />
    </ConsultSubsidyContextProvider>
);
export default ConsultSubsidyWithProvider;
